import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mr-3 v-theme--light" }
const _hoisted_2 = {
  key: 0,
  class: "row mr-3 v-theme--light ml-4 no-padding"
}
const _hoisted_3 = { class: "row align-items-center no-padding" }
const _hoisted_4 = { class: "col-12 col-lg" }
const _hoisted_5 = { class: "form-label" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "row align-items-center no-padding" }
const _hoisted_8 = { class: "col-12 col-lg" }
const _hoisted_9 = { class: "form-label" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "row align-items-center no-padding" }
const _hoisted_12 = { class: "col-12 col-lg" }
const _hoisted_13 = { class: "form-label" }
const _hoisted_14 = { class: "col" }
const _hoisted_15 = {
  key: 0,
  class: "row align-items-center no-padding"
}
const _hoisted_16 = { class: "col" }
const _hoisted_17 = { class: "form-label" }
const _hoisted_18 = { class: "col" }

import SettingFormInput from "@/components/VehicleFormParts/SettingFormInput.vue";
import Toggle from "@/components/VehicleFormParts/SettingFormToggle.vue";
import {ref, toRefs, watch, reactive, computed} from 'vue'
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'SpeedAlertSubSetting',
  props: {
  modelValue: { type: Object, default: () => ({}) },
  selectDefault: Boolean,
  errors: { type: Object, default: () => ({}) },
  formInputs: {},
  operationOfficeId: null,
  deviceId: null,
  isInstallationOffice: {
    type: Boolean,
    default: false
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props
const isSpeedLimitAlert = ref('ON');
const setDelayTime = ref<number>(0);
const isAlertTiming = ref('1');
const setSpeedLimitInterval = ref<string>('15');
const selectItemSpeedLimitInterval = reactive([
  { title: i18n.global.t('pages.vehicles.form.iniFileSetting.speedAlert.continuous'), value: '0' },
  { title: i18n.global.t('pages.vehicles.form.iniFileSetting.speedAlert.fifteenSeconds'), value: '15' },
  { title: i18n.global.t('pages.vehicles.form.iniFileSetting.speedAlert.thirtySeconds'), value: '30' },
  { title: i18n.global.t('pages.vehicles.form.iniFileSetting.speedAlert.fortyFiveSeconds'), value: '45' },
  { title: i18n.global.t('pages.vehicles.form.iniFileSetting.speedAlert.sixtySeconds'), value: '60' },
]);
const selectItemSpeedLimitTiming = reactive([
  { title: i18n.global.t('pages.vehicles.form.iniFileSetting.speedAlert.onlyExcess'), value: '0' },
  { title: i18n.global.t('pages.vehicles.form.iniFileSetting.speedAlert.continuation'), value: '1' },
]);
const readonlyInputs = ref<any[]>([]);
const { formInputs } = toRefs(props);
const errorKeyPrefix = ref('initial_params.speed_alert');

const form = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
})

const formFieldOptions = computed(() => {
  const parentKey = 'speed_alert';

  return {
    isSpeedLimitAlert: getShowAndRequiredAndErrors(parentKey, ['speed_limit_high_on', 'speed_limit_normal_on']),
    isAlertTiming: getShowAndRequiredAndErrors(parentKey, ['speed_limit_high_timing', 'speed_limit_normal_timing']),
    speedLimitHigh: getShowAndRequiredAndErrors(parentKey, ['speed_limit_high']),
    speedLimitNormal: getShowAndRequiredAndErrors(parentKey, ['speed_limit_normal']),
    setDelayTime: getShowAndRequiredAndErrors(parentKey, ['speed_limit_high_delay', 'speed_limit_normal_delay']),
  };
});

const emit = __emit;

const autoCompleteToggles = () => {
  isSpeedLimitAlert.value = form.value.speed_limit_high_on == 'ON' && form.value.speed_limit_normal_on == 'ON' ? 'ON' : 'OFF';
  isAlertTiming.value = form.value.speed_limit_normal_timing == '1' && form.value.speed_limit_high_timing == '1' ? '1' : '0';
};

const autoCompleteDelays = () => {
  if (form.value.speed_limit_normal_delay && form.value.speed_limit_high_delay) {
    setDelayTime.value = form.value.speed_limit_normal_delay;
  }
};

const autoCompleteSelects = () => {
  if (form.value.speed_limit_normal_interval && form.value.speed_limit_high_interval) {
    setSpeedLimitInterval.value = form.value.speed_limit_normal_interval;
  }
};

const getShowAndRequiredAndErrors = (parentKey: string, formKeys: string[]) => {
  if (!props.formInputs?.form[parentKey]) {
    return {
      isShow: false,
      isRequired: false,
      errors: null
    };
  }

  const keys = Object.keys(props.formInputs.form[parentKey]);

  const result = formKeys.map(formKey => {
    return {
      isShow: keys.includes(formKey),
      isRequired: !!props.formInputs.form[parentKey][formKey]?.required,
      errors: props.errors[`${errorKeyPrefix.value}.${formKey}`]
    };
  });

  return {
    isShow: result.every(item => item.isShow),
    isRequired: result.every(item => item.isRequired),
    errors: result.map(item => item.errors).filter(error => error)
  };
};

watch(() => isSpeedLimitAlert.value, (value) => {
  form.value.speed_limit_high_on = value;
  form.value.speed_limit_normal_on = value;
});

watch(() => setDelayTime.value, (value) => {
  form.value.speed_limit_high_delay = value;
  form.value.speed_limit_normal_delay = value;
});

watch(() => isAlertTiming.value, (value) => {
  form.value.speed_limit_high_timing = value;
  form.value.speed_limit_normal_timing = value;
});

watch(() => setSpeedLimitInterval.value, (value) => {
  form.value.speed_limit_high_interval = value;
  form.value.speed_limit_normal_interval = value;
});

watch(() => form.value.speed_limit_high_on, (value) => {
  form.value.speed_limit_normal_on = value;
});

watch(() => props.modelValue, () => {
  if (props.modelValue) {
    autoCompleteToggles();
    autoCompleteDelays();
    autoCompleteSelects();
  }
}, { immediate: true });

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Toggle, {
        label: _unref(i18n).global.t('pages.vehicles.form.iniFileSetting.speedAlert.speedLimitAlert'),
        modelValue: isSpeedLimitAlert.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isSpeedLimitAlert).value = $event)),
        formInputs: _unref(formInputs),
        isShow: formFieldOptions.value.isSpeedLimitAlert.isShow,
        isRequired: formFieldOptions.value.isSpeedLimitAlert.isRequired,
        disabled: (__props.selectDefault && readonlyInputs.value.includes('speed_limit_high_on') && readonlyInputs.value.includes('speed_limit_normal_on')) || __props.isInstallationOffice
      }, null, 8, ["label", "modelValue", "formInputs", "isShow", "isRequired", "disabled"])
    ]),
    (isSpeedLimitAlert.value === 'ON')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("label", _hoisted_5, _toDisplayString(_unref(i18n).global.t('pages.vehicles.form.iniFileSetting.speedAlert.alertSpeedSettings')), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(SettingFormInput, {
                label: _unref(i18n).global.t('pages.vehicles.form.iniFileSetting.speedAlert.expresswayKph'),
                modelValue: form.value.speed_limit_high,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.speed_limit_high) = $event)),
                isShow: formFieldOptions.value.speedLimitHigh.isShow,
                isRequired: formFieldOptions.value.speedLimitHigh.isRequired,
                type: "number",
                max: 200,
                colClassNumber: 0,
                formInputs: _unref(formInputs),
                readonly: (__props.selectDefault && readonlyInputs.value.includes('speed_limit_high')) || __props.isInstallationOffice,
                errors: formFieldOptions.value.speedLimitHigh.errors
              }, null, 8, ["label", "modelValue", "isShow", "isRequired", "formInputs", "readonly", "errors"]),
              _createVNode(SettingFormInput, {
                label: _unref(i18n).global.t('pages.vehicles.form.iniFileSetting.speedAlert.generalRoadKph'),
                modelValue: form.value.speed_limit_normal,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.speed_limit_normal) = $event)),
                isShow: formFieldOptions.value.speedLimitNormal.isShow,
                isRequired: formFieldOptions.value.speedLimitNormal.isRequired,
                type: "number",
                max: 200,
                colClassNumber: 0,
                formInputs: _unref(formInputs),
                readonly: (__props.selectDefault && readonlyInputs.value.includes('speed_limit_normal')) || __props.isInstallationOffice,
                errors: formFieldOptions.value.speedLimitNormal.errors
              }, null, 8, ["label", "modelValue", "isShow", "isRequired", "formInputs", "readonly", "errors"])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(i18n).global.t('pages.vehicles.form.iniFileSetting.speedAlert.decisionTime')), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(SettingFormInput, {
                label: _unref(i18n).global.t('pages.vehicles.form.iniFileSetting.speedAlert.decisionTimeSeconds'),
                modelValue: setDelayTime.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((setDelayTime).value = $event)),
                isShow: formFieldOptions.value.setDelayTime.isShow,
                isRequired: formFieldOptions.value.setDelayTime.isRequired,
                type: "number",
                max: 600,
                colClassNumber: 0,
                formInputs: _unref(formInputs),
                readonly: (__props.selectDefault && readonlyInputs.value.includes('speed_limit_high_delay') && readonlyInputs.value.includes('speed_limit_normal_delay')) || __props.isInstallationOffice,
                errors: formFieldOptions.value.setDelayTime.errors
              }, null, 8, ["label", "modelValue", "isShow", "isRequired", "formInputs", "readonly", "errors"])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("label", _hoisted_13, _toDisplayString(_unref(i18n).global.t('pages.vehicles.form.iniFileSetting.speedAlert.alertTiming')), 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_v_select, {
                "hide-details": "auto",
                class: "small mt-2",
                label: _unref(i18n).global.t('pages.vehicles.form.iniFileSetting.speedAlert.alertTimingLabel'),
                modelValue: isAlertTiming.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((isAlertTiming).value = $event)),
                items: selectItemSpeedLimitTiming,
                clearable: false,
                disabled: (__props.selectDefault && readonlyInputs.value.includes('speed_limit_high_timing') && readonlyInputs.value.includes('speed_limit_normal_timing')) || __props.isInstallationOffice
              }, null, 8, ["label", "modelValue", "items", "disabled"])
            ])
          ]),
          (isAlertTiming.value === '1')
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("label", _hoisted_17, _toDisplayString(_unref(i18n).global.t('pages.vehicles.form.iniFileSetting.speedAlert.alertInterval')), 1)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_v_select, {
                    "hide-details": "auto",
                    class: "small mt-2",
                    label: _unref(i18n).global.t('pages.vehicles.form.iniFileSetting.speedAlert.alertInterval'),
                    modelValue: setSpeedLimitInterval.value,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((setSpeedLimitInterval).value = $event)),
                    items: selectItemSpeedLimitInterval,
                    clearable: false,
                    disabled: __props.isInstallationOffice
                  }, null, 8, ["label", "modelValue", "items", "disabled"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})